import {useContext, useEffect, useRef, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import "../styles/NavigationBarStyle.css"
import AuthContext from "../contexts/AuthContext";
//import SideBar from "./SideBar";
//import LanguageSelector from "./LanguageSelector";
import { useCart } from "../contexts/CartContext";




function NavigationBar() {
   
    const [menuOpen, setMenuOpen] = useState(false);
    const {logout} = useContext(AuthContext);
    const navRef = useRef(null);
    const location = useLocation();
    const [showDashboardModal, setShowDashboardModal] = useState(false);
    const [dashboardPassword, setDashboardPassword] = useState("");
    const [dashboardError, setDashboardError] = useState("");

    const { cartItems } = useCart();
    const name = localStorage.getItem("userName") || "Misafir";
    const userRole = localStorage.getItem("userRole") || "Misafir";

    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const toggleProfileMenu = () => setProfileMenuOpen(!profileMenuOpen);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".profile-dropdown")) {
                setProfileMenuOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);


    const handleDashboardClick = (e) => {
        e.preventDefault();
        setShowDashboardModal(true);
        setDashboardPassword("");
        setDashboardError("");
    };

    const handleDashboardPasswordSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/verify-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ password: dashboardPassword })
            });

            if (response.ok) {
                setShowDashboardModal(false);
                setDashboardPassword("");
                window.location.href = "/dashboard";
            } else {
                setDashboardError("Şifre yanlış!");
            }
        } catch (error) {
            console.error("Şifre kontrol hatası:", error);
            setDashboardError("Sunucuya ulaşılamadı.");
        }
    };
    // Close menu when clicking outside and on route change
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setMenuOpen(false); // Close the menu on route change
    }, [location]);



    const handleLogout = () => {

        logout();
        //alert("Çıkış yapıldı");
    };

    return (
        <header className="header-area header-sticky">
            <div className="container">
                {showDashboardModal && (
                    <div className="modal-overlay">
                        <div className="modal-box">
                            <form onSubmit={handleDashboardPasswordSubmit}>
                                <label>Yönetim paneline erişmek için şifre giriniz:</label>
                                <input
                                    type="password"
                                    value={dashboardPassword}
                                    onChange={e => setDashboardPassword(e.target.value)}
                                    autoFocus
                                />
                                {dashboardError && <div className="error-message">{dashboardError}</div>}
                                <div style={{marginTop: "12px"}}>
                                    <button type="submit">Giriş</button>
                                    <button type="button" onClick={() => setShowDashboardModal(false)}
                                            style={{marginLeft: "8px"}}>Vazgeç
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                <div className="row">
                    <div className="col-12">
                        <nav className="main-nav" ref={navRef}>
                            {/* Logo - Sadece MeduVR logosu */}
                            <Link className="logo-meduvr" to="/">
                                <img src="/images/logo.svg" alt="MeduVR Logo"/>
                            </Link>

                            {/* Menu */}
                            <ul className={`nav ${menuOpen ? "active" : ""}`}>
                                <li className="has-sub">
                                    <Link to="/">Ana Sayfa</Link>
                                </li>
                                {/*   <ul className="sub-menu">
                                        <li><Link to="/home#courses">Hakkımızda</Link></li>
                                        <li><Link to="/home#our-facts">Kurslar</Link></li>
                                        <li><Link to="/home#contact">İletişim</Link></li>
                                    </ul>
                                </li>

                                <li className="has-sub">
                                    <Link to="/meetings">Meetings</Link>
                                    <ul className="sub-menu">
                                        <li><Link to="/upcoming-meetings">Upcoming Meetings</Link></li>
                                        <li><Link to="/meeting-details">Meeting Details</Link></li>
                                        <li><Link to="/meetings">All Meetings</Link></li>
                                    </ul>
                                </li>

                                <li><Link to="/contact">Contact Us</Link></li> */}
                                <li className="has-sub">
                                    <h4>Kurumsal</h4>
                                    <ul className="sub-menu">
                                        <li><Link to="/about">Hakkımızda</Link></li>
                                        <li><Link to="/history">Tarihçe</Link></li>
                                        <li><Link to="/our-mission">Misyonumuz</Link></li>
                                        <li><Link to="/our-vision">Vizyonumuz</Link></li>
                                        <li><Link to="/founder-message">Kurucumuzdan Mesaj</Link></li>
                                        {/*

                                        <li><Link to="/our-partners">Our Partners</Link></li>
                                        <li><Link to="/our-privacy-policy">Privacy Policy</Link></li>
                                        <li><Link to="/our-terms-and-conditions">Terms and Conditions</Link></li>
                                        <li><Link to="/our-legal-notice">Legal Notice</Link></li>
                                        <li><Link to="/our-cookies-policy">Cookies Policy</Link></li>
                                        <li><Link to="/our-complaints-policy">Complaints Policy</Link></li>*/}
                                    </ul>
                                </li>

                                <li className="has-sub">
                                    <Link to="/courses">Kurslar</Link>
                                </li>
                                <li className="has-sub">
                                    <Link to="/instructors">Eğitmenler</Link>
                                </li>

                                <li className="has-sub">
                                    <Link to="/faq">Sık Sorulan Sorular</Link>
                                </li>

                                {/*
                                <li className="has-sub">
                                    <Link to="/books">Kitaplar</Link>
                                </li>
                                */}


                                <li className="has-sub">
                                    <Link to="/contact-us">Bize Ulaşın</Link>
                                </li>

                                {/*
                                <li className="has-sub">
                                    <Link to="/cart">
                                        <i className="fa fa-shopping-cart" style={{marginRight: "6px"}}
                                           aria-hidden="true"></i>
                                        Sepetim ({cartItems.length})
                                    </Link>
                                </li>
                                */}
                                {console.log("Cart Items:", cartItems)}


                            </ul>
                            {/* Profile Menu */}
                            <div className="profile-dropdown">


                                <div className="profile-button" onClick={toggleProfileMenu}>
                                    <img src="./images/profile-icon.png" alt="Profil" className="profile-icon"/>

                                </div>


                                {profileMenuOpen && (
                                    <div className="profile-menu">
                                        <div className="profile-info">
                                            <div className="profile-initials">
                                                {localStorage.getItem("userEmail")
                                                    ? name?.trim().split(" ").map(word => word[0]).join("").toUpperCase()
                                                    : "?"}
                                            </div>
                                            <div>
                                                <div className="profile-name">
                                                    {localStorage.getItem("userEmail") ? name : "Misafir"}
                                                </div>
                                                <div className="profile-email">
                                                    {localStorage.getItem("userEmail") || ""}
                                                </div>
                                            </div>
                                        </div>

                                        {localStorage.getItem("userEmail") ? (
                                            <ul>
                                                <hr/>
                                                <li><Link to="/my-courses">📚 Öğrenim İçeriğim</Link></li>
                                                <li>
                                                    <Link to="/personal-learning" className="profile-link">
                                                        🧭 Kişisel Öğrenme Yolu
                                                    </Link>
                                                </li>

                                                {/*
                                                <hr/>
                                                <li><Link to="/cart">🛒 Sepetim</Link></li>

*/}
                                                <hr/>

                                                <li>
                                                    <a href="/" onClick={handleDashboardClick}>🛠️ Yönetim Paneli</a>
                                                </li>
                                                <li><Link to="/user-progress-analysis">📈 Gelişim Analizleri</Link></li>

                                                {/* 🔐 Administration */}
                                                {userRole === "ADMIN" && (
                                                    <>
                                                        <hr/>
                                                        <li>
                                                            <a href="/" onClick={handleDashboardClick}>🛠️ Yönetim Paneli</a>
                                                        </li>
                                                        <li><Link to="/statistics">📊 İstatistikler</Link></li>
                                                        <li><Link to="/user-progress-analysis">📈 Gelişim Analizleri</Link></li>
                                                    </>
                                                )}
                                                <hr/>
                                                <li><Link to="/account">⚙️ Hesap Ayarları</Link></li>
                                                <li><a href="/" onClick={handleLogout}>🚪 Çıkış Yap</a></li>
                                                <hr/>
                                            </ul>
                                        ) : (
                                            <ul>
                                                <li><Link to="/signin">Giriş Yap</Link></li>
                                                <li><Link to="/signup">Kayıt Ol</Link></li>
                                            </ul>
                                        )}

                                    </div>
                                )}
                            </div>


                            {/* Mobile Menu Button */}
                            <button className="menu-trigger" onClick={() => setMenuOpen(!menuOpen)}>
                                <span>☰</span>
                            </button>

                            {/* Language
                            <LanguageSelector/>
*/}

                            {/* Search Bar
                            <form className="search-form">
                                <input type="text" placeholder="Search..."/>
                                <button type="submit">🔍</button>
                            </form>*/}

                            <Link className="logo-rsg" to="https://www.linkedin.com/company/rsgturkiye/posts/?feedView=all">
                                <img src="/Logo2.png" alt="Logo" style={{width: "64px"}}/>
                            </Link>

                        </nav>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default NavigationBar;
